import { useAppDispatch } from 'app/core/hooks'
import { Crd0102CtlrOut } from 'app/core/models/api/crd/crd0102'
import { Dep0103CtlrOut } from 'app/core/models/api/dep/dep0103'
import { Dep0410CtlrOut } from 'app/core/models/api/dep/dep0410'
import { comboProduct } from 'app/core/models/slice/combo/comboProduct'
import { comboProductList } from 'app/core/models/slice/combo/comboProductList'
import { issueCardInfo } from 'app/core/models/slice/crd/issueCardInfo'
import { useLazySelectDep0306Query } from 'app/core/services/prd/crd/crd.service'
import {
    useLazySelectDep0103FalseQuery,
    useLazySelectDep0302Query,
    useLazySelectDep0410Query,
} from 'app/core/services/prd/dep.service'
import { setFacInfoArr } from 'app/core/slices/com/facInfo.slice'
import { setElecFinanceInfo } from 'app/core/slices/fns/sbk/sbkslice'
import {
    clearIssueCardInfo,
    setHomeIssueCardInfo,
} from 'app/core/slices/product/issueCardInfoslice.slice'
import { clearIssueCardPreInqInfo } from 'app/core/slices/product/IssueCardPreInqInfo.slice'
import React from 'react'
import useBasePage from '../base-page.hook'
import { useCommonCode, WtcnsUrlAdr } from './commonCode.hook'
import { useProductJoin } from './product.hook'
import { setCusInfoArr } from 'app/core/slices/user/user.slice'

/**
 * 나라사랑콤보구분코드
 * 01 : 나라사랑통장 + 스마트뱅킹 + 나라사랑카드
 * 02 : 나라사랑통장 + 나라사랑카드
 * 03 : 스마트뱅킹 + 나라사랑카드
 */
type NaraCmbTcd = '' | '01' | '02' | '03'
/**
 * 비대면콤보유형코드
 *
 * "01"    입출식_스마트뱅킹 (PRDCMB0101 - 건너뛰기)
 *
 * "02"    입출식_적립식_스마트뱅킹
 *
 * "03"    입출식_스마트뱅킹_체크카드
 * @type {string}
 */
const nofcCmbTcd = '03'

const narasarangTongjang = {
    allPdcd: '01111010061',
    pdlnCd: '01',
    pdgrCd: '11',
    pdtmCd: '101',
    pdcd: '0061',
}
const narasarangCard = {
    allPdcd: '12112960001',
    pdlnCd: '12',
    pdgrCd: '11',
    pdtmCd: '296',
    pdcd: '0001',
}

const sbkPrdObj: comboProduct = {
    nofcCmbTcd: nofcCmbTcd,
    nofcCmbPgrsYn: '',
    nofcRlncPgrsScd02: '',
    nfchPrcfGrpCd: '401',
    nfchPrcfGrpCdNm: '',
    rltdPdlnCd: '04',
    rltdPdgrCd: '11',
    rltdPdtmCd: '401',
    rltdPdcd: '0001',
    rltdPdm: '스마트뱅킹 신청하기',
    allPdcd: '04114010001',
}

export const useNarasarang = () => {
    const router = useBasePage()
    const dispatch = useAppDispatch()
    const {
        user,
        setJoinProductArr,
        setJoinProductObArr,
        setComboProductObArr,
        setComboProductListObArr,
        setCusInfoObArr,
        clearJoinProduct,
        clearJoinProcessData,
        clearComboProduct,
        clearComboProductList,
        joinProduct,
        comboProductList,
    } = useProductJoin()
    // 상품정보조회
    const [fetchDep0302] = useLazySelectDep0302Query()
    // 카드정보조회
    const [fetchDep0306] = useLazySelectDep0306Query()

    const [fetchDep0410] = useLazySelectDep0410Query()

    // 상품 가입 선조회
    const [fetchDep0103] = useLazySelectDep0103FalseQuery()

    const { fetchCommonCode: fetchUseNaraNvrid } = useCommonCode({
        dsrnTgtBacd: '110',
        cdgpId: 'ETC',
        ccddId: 'USE_NARA_NVRID',
        skipProgress: true,
        fetchOnLoad: false,
    })

    const isNarasarangInstantJoin = joinProduct.isNarasarangInstantJoin

    const isNarasarangPostLinkage = joinProduct.isNarasarangPostLinkage

    const isNasaca3rdGen = isNarasarangInstantJoin || isNarasarangPostLinkage

    const presignRef = React.useRef(joinProduct.isPreSign)
    const nowAllPdcd = React.useRef(narasarangCard.allPdcd)

    /** enlsPathCd 모집경로구분코드 나사카3기 = 8 (내점방문) */
    const enlsPathCd = isNarasarangInstantJoin ? '8' : ''

    /**
     * 나사카 clear
     */
    const clearNarasarang = () => {
        setJoinProductArr([
            { key: 'isNarasarangInstantJoin', value: false },
            { key: 'isNarasarangPostLinkage', value: false },
            { key: 'isPreSign', value: false },
            { key: 'presignInfo', value: undefined },
            { key: 'comboFlage', value: false},
			{ key: 'defaultBrcd', value: ''},
			{ key: 'mngmBrcd', value: ''},
			{ key: 'krnBrm', value: ''}
        ])
		if(user.cusInfo.mrknCretBrcd == '1111' || 
			(user.cusInfo.mrknCretBrcd >= '0972' && user.cusInfo.mrknCretBrcd <= '0981')){
			/*setCusInfoObArr({
				mrknCretBrcd: '',
			    bankBrncNm: ''
			})*/
			dispatch(setCusInfoArr([
				{key : 'mrknCretBrcd', value : ''},
				{key : 'bankBrncNm', value : ''}]))
		}
        clearComboProduct()
        clearComboProductList()
        dispatch(clearIssueCardInfo())
        dispatch(clearIssueCardPreInqInfo())
    }

    /**
     * 나라사랑카드 3기 신청 정보 셋팅
     */
    const initNarasarang = () => {
        clearJoinProduct()
        clearComboProduct()
        clearComboProductList()
        dispatch(clearIssueCardInfo())
        dispatch(clearIssueCardPreInqInfo())
        dispatch(
            setFacInfoArr([
                {
                    key: 'facFileCount',
                    value: 0,
                },
            ])
        )
        setJoinProductArr([
            { key: 'isNarasarangInstantJoin', value: true },
            { key: 'isPreSign', value: false },
            { key: 'presignInfo', value: undefined },
            { key: 'allPdcd', value: narasarangCard.allPdcd },
            { key: 'pdlnCd', value: narasarangCard.pdlnCd },
            { key: 'pdgrCd', value: narasarangCard.pdgrCd },
            { key: 'pdtmCd', value: narasarangCard.pdtmCd },
            { key: 'pdcd', value: narasarangCard.pdcd },
        ])
    }

    /**
     * 나라사랑카드 3기 사후연동 정보 셋팅
     */
    const initPostLink = () => {
        clearJoinProduct()
        setJoinProductObArr({ isNarasarangPostLinkage: true })
    }

    const _fetchNpayPresignInfo = () => {
        return fetchDep0410({ userCi: user.info.userCi })
    }

    /**
     * 나라사랑카드 콤보셋팅
     *
     * 나사통, 스뱅 있는 경우 셋팅 X 카드만 단독가입
     *
     * 1. 당행고객 X
     *  1-1. 입 스 체   ( 나라사랑통장 + 스마트뱅킹 + 나라사랑카드 )
     *
     * 2. 당행고객 O
     *  1-1. 입 스 체   ( 나라사랑통장 + 스마트뱅킹 + 나라사랑카드 )
     *  1-2. 입 체      ( 나라사랑통장 + 나라사랑카드 )  >> 콤보 X 나라사랑통장 가입 후 나라사랑카드 가입
     *  1-3. 스 체      ( 스마트뱅킹 + 나라사랑카드 )  >> 콤보 X 스마트뱅킹 가입 후 나라사랑카드 가입
     */
    const setNarasarangComboProduct: (mobileAuth: Dep0103CtlrOut) => Promise<{
        nextPage?: string
        isError: boolean
        errorMsg?: string
    }> = async (mobileAuth) => {
        const nasatong = {} as comboProduct
        const nasaca = {} as comboProduct
        const comboProductList: comboProduct[] = []
        const acntList = mobileAuth.acntList

        /*********************************************
         * 나라사랑카드 네이버페이 사전신청 내역 조회
         ********************************************/
        const dep0410Result = await _fetchNpayPresignInfo()

        if (dep0410Result.isError) {
            return {
                isError: true,
                errorMsg: dep0410Result.error['data'].bscMsg,
            }
        }

        if (dep0410Result.data?.nvrPyRucd === '0000') {
            presignRef.current = true
            setJoinProductArr([
                { key: 'isPreSign', value: true },
                { key: 'presignInfo', value: dep0410Result.data },
                {
                    key: 'lgnLnkId',
                    value: dep0410Result.data?.nvrAplcMngmNo ?? '',
                },
            ])
        } else {
            presignRef.current = false
            setJoinProductArr([
                { key: 'isPreSign', value: false },
                { key: 'presignInfo', value: undefined },
                {
                    key: 'lgnLnkId',
                    value: '',
                },
            ])
        }

        /*********************************************
         * 나사통, 나사카 상세정보 불러오기
         ********************************************/
        const nasatongInfo = (
            await fetchDep0302({
                allPdcd: narasarangTongjang.allPdcd,
            })
        ).data
        const nasacaInfo = (
            await fetchDep0306({
                allPdcd: narasarangCard.allPdcd,
            })
        ).data

        /***********************************************
         * 콤보 productList 정의
         **********************************************/
        nasatong.nofcCmbTcd = nofcCmbTcd
        nasatong.allPdcd = nasatongInfo.allPdcd
        nasatong.nfchPrcfGrpCd = nasatongInfo.nfchPrcfGrpCd
        nasatong.nfchPrcfGrpCdNm = nasatongInfo.nfchPrcfGrpCdNm
        nasatong.nofcCmbPgrsYn = ''
        nasatong.nofcRlncPgrsScd02 = ''
        nasatong.rltdPdlnCd = nasatongInfo.pdlnCd
        nasatong.rltdPdgrCd = nasatongInfo.pdgrCd
        nasatong.rltdPdtmCd = nasatongInfo.pdtmCd
        nasatong.rltdPdcd = nasatongInfo.pdcd
        nasatong.rltdPdm = nasatongInfo.nfchOfrPdm

        nasaca.nofcCmbTcd = nofcCmbTcd
        nasaca.allPdcd = nasacaInfo.allPdcd
        nasaca.nfchPrcfGrpCd = nasacaInfo.nfchPrcfGrpCd
        nasaca.nfchPrcfGrpCdNm = nasacaInfo.nfchPrcfGrpCdNm
        nasaca.nofcCmbPgrsYn = ''
        nasaca.nofcRlncPgrsScd02 = ''
        nasaca.rltdPdlnCd = nasacaInfo.pdlnCd
        nasaca.rltdPdgrCd = nasacaInfo.pdgrCd
        nasaca.rltdPdtmCd = nasacaInfo.pdtmCd
        nasaca.rltdPdcd = nasacaInfo.pdcd
        nasaca.rltdPdm = nasacaInfo.nfchOfrPdm

        let nextPage = '/prd/crd/PRDCRD0101'

        /** 고객 보유계좌에 나라사랑통장 있는지 FIND */
        const targetAcnt = acntList.find(
            (x) => x.pdcd === '0061' && x.pdm.indexOf('나라사랑') !== -1
        )

        //나사랑통장 X && 스마트뱅킹 가입 X
        if (!targetAcnt && mobileAuth.ebkJnngYn !== 'Y') {
            comboProductList.push(nasatong)
            comboProductList.push(sbkPrdObj)
            comboProductList.push(nasaca)
        } else {
            //나라사랑통장 보유 O && 스마트뱅킹 가입 X
            //스마트 뱅킹 단독 후 >>> 나사카 단독 가입
            if (targetAcnt && mobileAuth.ebkJnngYn !== 'Y') {
                dispatch(
                    setElecFinanceInfo({
                        allPdcd: sbkPrdObj.allPdcd,
                        smbkGubun: 'smbkAplc',
                    })
                )
                setJoinProductArr([
                    { key: 'allPdcd', value: sbkPrdObj.allPdcd },
                    { key: 'pdlnCd', value: sbkPrdObj.rltdPdlnCd },
                    { key: 'pdgrCd', value: sbkPrdObj.rltdPdgrCd },
                    { key: 'pdtmCd', value: sbkPrdObj.rltdPdtmCd },
                    { key: 'pdcd', value: sbkPrdObj.rltdPdcd },
                    { key: 'nfchPrcfGrpCd', value: sbkPrdObj.nfchPrcfGrpCd },
                    { key: 'pdm', value: sbkPrdObj.rltdPdm },
                ])
                nowAllPdcd.current = sbkPrdObj.allPdcd
                nextPage = '/fns/sbk/FNSSBK0105'
            }
            //나라사랑통장 보유 X && 스마트뱅킹 가입 O
            //나라사랑통장 단독 후 >>> 나사카 단독 가입
            else if (!targetAcnt && mobileAuth.ebkJnngYn === 'Y') {
                setJoinProductArr([
                    { key: 'allPdcd', value: nasatongInfo.allPdcd },
                    { key: 'pdlnCd', value: nasatongInfo.pdlnCd },
                    { key: 'pdgrCd', value: nasatongInfo.pdgrCd },
                    { key: 'pdtmCd', value: nasatongInfo.pdtmCd },
                    { key: 'pdcd', value: nasatongInfo.pdcd },
                    { key: 'nfchPrcfGrpCd', value: nasatongInfo.nfchPrcfGrpCd },
                    { key: 'pdm', value: nasatongInfo.nfchOfrPdm },
                ])
                nowAllPdcd.current = nasatongInfo.allPdcd
                nextPage = '/prd/dep/PRDDEP0103'
            }
            //나라사랑통장 보유 O && 스마트뱅킹 가입 O
            //나라사랑카드 단독가입
            //이미 선조회를 나라사랑카드로 진행했기떄문에 따로 안해도됨.
            else if (!targetAcnt && mobileAuth.ebkJnngYn === 'Y') {
            }
        }

        /***********************************************
         * 리스트에 다건 있는 경우 콤보프로세스 ㄱㄱ ( 입 스 체 )
         * 리스트에 한건만 있는 경우 단독가입 (스마트뱅킹, 나사카)
         **********************************************/
        if (comboProductList.length > 1) {
            setJoinProductArr([
                { key: 'comboFlage', value: true },
                { key: 'allPdcd', value: nasatongInfo.allPdcd },
                { key: 'pdlnCd', value: nasatongInfo.pdlnCd },
                { key: 'pdgrCd', value: nasatongInfo.pdgrCd },
                { key: 'pdtmCd', value: nasatongInfo.pdtmCd },
                { key: 'pdcd', value: nasatongInfo.pdcd },
                { key: 'nfchPrcfGrpCd', value: nasatongInfo.nfchPrcfGrpCd },
                { key: 'pdm', value: nasatongInfo.nfchOfrPdm },
            ])
            // userInfo.cusInfo
            setCusInfoObArr({
                nofcCmbTcd: nofcCmbTcd,
            })
            // comboProduct
            setComboProductObArr(comboProductList[0])

            // comboProductList
            setComboProductListObArr(comboProductList)

            nextPage = '/prd/cmb/PRDCMB0104'
        } else {
            clearComboProduct()
            clearComboProductList()

            if (nowAllPdcd) {
                //--가입 상품 선조회, ctoaIqyn를 통해 계좌까지 조회해야한다.
                const dep0103Result = await fetchDep0103({
                    allPdcd: nowAllPdcd.current,
                    ctoaIqyn: 'Y',
                    instantJoinYn: isNarasarangInstantJoin ? 'Y' : '',
                })

                if (dep0103Result.error) {
                    return {
                        isError: true,
                        errorMsg: dep0103Result.error?.['data']?.bscMsg,
                    }
                }
            }
        }

        return {
            isError: false,
            nextPage: nextPage,
        }
    }

    /**
     * 나라사랑카드 3기
     * 현재 페이지 별 다음 페이지 정의
     */
    const replacePageWithData = async (data?: object) => {
        const location = router.curLocation

        let nextPageUrl = '/'

        switch (location[location.length - 1]) {
            //휴대폰 본인인증 브릿지 >
            case 'COMATH0103':
                {
                    const resultUseNaraNvrid = await fetchUseNaraNvrid()

                    //ㅋㅋ 데이터없으면 비어있는리스트고 찾은 단건데이터있으면 오브젝트 ㅋㅋㅋㅋ
                    const useNaraNvrid = resultUseNaraNvrid.data
                        ?.data as unknown

                    /**
                     * 나라사랑카드 3기 네이버ID조회가 미완성이므로 캐시에서
                     * 나라사랑카드 네이버ID 사용여부가 N이면 네이버ID 선택으로 보내지 않는다.
                     */
                    if (
                        useNaraNvrid &&
                        !(useNaraNvrid instanceof Array) &&
                        (useNaraNvrid as WtcnsUrlAdr).cdAtrbEtc1Con === 'N'
                    ) {
                        nextPageUrl = '/com/ath/COMATH0101' // 신분증인증방법 안내
                        break
                    }

                    /**
                     * 네이버 사전신청 정보 없으면 네이버ID 선택, 있으면 신분증인증방법 안내
                     * 사전신청관리번호 저장 setJoinProductObArr({ lgnLnkId: selected.idKey })
                     */
                    if (presignRef.current) {
                        nextPageUrl = '/com/ath/COMATH0101' // 신분증인증방법 안내
                    } else {
                        if (nowAllPdcd.current === narasarangCard.allPdcd) {
                            nextPageUrl = '/prd/crd/PRDCRD0402' // 네이버 ID 선택
                        } else {
                            nextPageUrl = '/com/ath/COMATH0101' // 신분증인증방법 안내
                        }
                    }
                }
                break
            case 'PRDCRD0402':
                {
                    if (isNarasarangPostLinkage) {
                        nextPageUrl = '/prd/crd/PRDCRD0502' // 나라사랑카드 사후연동 완료
                    } else {
                        nextPageUrl = '/com/ath/COMATH0101' // 신분증인증방법 안내
                    }
                }
                break
            case 'PRDDEP0107': // 입출금 가입완료 > 체크카드 상품상세
            case 'FNSSBK0108': // 스마트뱅킹 가입완료 > 체크카드 상품상세
                {
                    setJoinProductObArr({ catlDcd: '302' })
                    setJoinProductObArr({
                        isNarasarangInstantJoin: true,
                        allPdcd: narasarangCard.allPdcd,
                        pdlnCd: narasarangCard.pdlnCd,
                        pdgrCd: narasarangCard.pdgrCd,
                        pdtmCd: narasarangCard.pdtmCd,
                        pdcd: narasarangCard.pdcd,
                    })
                    dispatch(
                        setHomeIssueCardInfo({
                            studentCardYn: 'N',

                            pdlnCd: narasarangCard.pdlnCd,
                            pdgrCd: narasarangCard.pdgrCd,
                            newCard: '60',
                        } as issueCardInfo)
                    )
                    nextPageUrl = '/M0036' // 카드상품상세
                }
                break
            default:
                break
        }

        router.replacePageWithData(nextPageUrl, data ?? {})
    }

    return {
        enlsPathCd: enlsPathCd,
        isNarasarangInstantJoin: isNarasarangInstantJoin,
        isNarasarangPostLinkage: isNarasarangPostLinkage,
        isNasaca3rdGen: isNasaca3rdGen,
        clearNarasarang: clearNarasarang,
        initNarasarang: initNarasarang,
        initPostLink: initPostLink,
        setNarasarangComboProduct: setNarasarangComboProduct,
        replacePageWithData: replacePageWithData,
        fetchNpayPresign: _fetchNpayPresignInfo,
    }
}
